import React, { memo } from 'react';
import { CurrentPage } from '@avensia/nitro5-scope';
// This class exists as a memoized version of its props. Since props passed to Layout
// can change without the current page changes, we want to avoid re-rendering the
// current page when it hasn't changed.
const CurrentPageInternal = memo((props) => {
    return React.createElement(CurrentPage, null);
});
export default CurrentPageInternal;
